export default __webpack_public_path__ + "static/ueberblick-5494a444af9d9855b292d25fce1d71d2.webp";